import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

function visitorId() {
  let v = localStorage.getItem("pi_visitor");
  if (!v) {
    v = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`;
    localStorage.setItem("pi_visitor", v);
  }
  return v;
}

// Capte le paramètre ?ref d'un lien de parrainage, enregistre un clic anonyme
// et rattache l'utilisateur à son parrain après connexion. Aucune donnée personnelle.
export default function ReferralTracker() {
  const { user } = useAuth();

  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const ref = params.get("ref");
      if (!ref) return;
      localStorage.setItem("pi_ref", ref);
      api.post("/public/ref-hit", { ref, visitor: visitorId() }).catch(() => {});
      params.delete("ref");
      const qs = params.toString();
      window.history.replaceState({}, "", window.location.pathname + (qs ? `?${qs}` : "") + window.location.hash);
    } catch { /* noop */ }
  }, []);

  useEffect(() => {
    const ref = localStorage.getItem("pi_ref");
    if (user && user.id && ref && ref !== user.id) {
      api.post("/ref/attribute", { ref })
        .then(() => localStorage.removeItem("pi_ref"))
        .catch(() => {});
    }
  }, [user]);

  return null;
}
